export const appendComma = (word: string | null) => (word ? `${word},` : '');
